import type { GADataProps } from "@elements/GAData/GAData";
import type { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export type PhotoGalleryMetaDataProps = {
  sectionName: string;
  sectionTamilName: string;
};

export function PhotoGalleryMetaData({
  sectionName,
  sectionTamilName,
}: PhotoGalleryMetaDataProps): PageMetaDataValues {
  const level2 = sectionName.replace("-", " ");

  const metaTitle = `${sectionTamilName} | Today's Latest News in Tamil - Tamilmurasu, தமிழ் நியூஸ், அண்மையச் செய்திகள், தமிழ் முரசு`;
  const metaDescription = `${sectionTamilName} | அண்மையச் செய்திகள் - Get Latest News in Singapore, Tamilnadu, India, World & Sports News in Tamil. சிங்கப்பூர், தமிழ்நாடு, இந்தியா, உலக மற்றும் விளையாட்டு அண்மைய செய்திகளில் தமிழில் சமீபத்தியச் செய்திகளைப் பெறுங்கள்.`;

  const metaTags: MetaTagsProps = {
    title: metaTitle,
    description: metaDescription,
    slug: sectionName,
  };

  const gaData: GADataProps = {
    level2: level2,
    title: `${sectionName.replace("-", "_")}_index`,
    contentcat: 1,
    contenttype: undefined,
  };

  return {
    gaData,
    metaTags,
  };
}
